import * as React from 'react'


import { BaseIcon/*, Props*/ } from './BaseIcon'

export class BlankCalendar extends BaseIcon {
  /*constructor (props: Props) {
    super(props)
  }*/

  public render () {
    const className = this.props.className ? `${this.defaults.className} ${this.getSize()} ${this.props.className}`
      : `${this.defaults.className} ${this.getSize()}`

    //const viewBox = this.props.viewBox ? this.props.viewBox : this.defaults.viewBox

    // tslint:disable    
    return (
        <svg className={className}  viewBox='0 -960 960 960'>
        <path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z"/>
        </svg>
          )
  }
}
export default BlankCalendar
